<button (click)="throwTestError()">Test Sentry Error</button>
